import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=7f05e90d&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=7f05e90d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f05e90d",
  null
  
)

export default component.exports